import React from 'react';
import { SearchInput, SingleSelect } from '../../../components/common/Search';
import { SearchMode, TabType } from '../../Resource/types';

interface SearchControlsProps {
  searchTerm: string;
  searchMode: SearchMode;
  onSearchTermChange: (term: string) => void;
  onSearchModeChange: (mode: SearchMode) => void;
  activeTab?: TabType;
}

const SearchControls: React.FC<SearchControlsProps> = ({ 
  searchTerm, 
  searchMode, 
  onSearchTermChange, 
  onSearchModeChange,
  activeTab = TabType.PEOPLE
}) => {
  // Define search options based on active tab
  const getSearchOptions = () => {
    if (activeTab === TabType.TEAMS) {
      return [
        { value: SearchMode.NAME, label: 'Filter by team name' },
        { value: SearchMode.SKILLS, label: 'Filter by team member' },
        
      ];
    } else {
      return [
        { value: SearchMode.NAME, label: 'Filter by name' },
        { value: SearchMode.SKILLS, label: 'Filter by skill' },
        { value: SearchMode.TEAM, label: 'Filter by team' },
      ];
    }
  };

  // Define placeholders based on active tab and search mode
  const getPlaceholder = () => {
    if (activeTab === TabType.TEAMS) {
      return searchMode === SearchMode.NAME 
        ? "Search teams by name..." 
        : "Search by team member name or email...";
    } else {
      if (searchMode === SearchMode.NAME) {
        return "Search by name or email...";
      } else if (searchMode === SearchMode.SKILLS) {
        return "Search by skill name...";
      } else if (searchMode === SearchMode.TEAM) {
        return "Search by team name...";
      }
      return "Search...";
    }
  };

  // Define dropdown placeholder based on active tab
  const getDropdownPlaceholder = () => {
    if (activeTab === TabType.TEAMS) {
      return searchMode === SearchMode.NAME ? "Search by team name" : "Search by team member";
    } else {
      if (searchMode === SearchMode.NAME) {
        return "Search by name";
      } else if (searchMode === SearchMode.SKILLS) {
        return "Search by skill";
      } else if (searchMode === SearchMode.TEAM) {
        return "Filter by team";
      }
      return "Search";
    }
  };

  return (
    <div className="flex flex-row items-center gap-2">
      <SingleSelect
        key={`${activeTab}-${searchMode}`}
        name="searchMode"
        options={getSearchOptions()}
        placeholder={getDropdownPlaceholder()}
        defaultValue={getSearchOptions().find(option => option.value === searchMode)}
        onChange={(option) => {
          if (option?.value === SearchMode.NAME || option?.value === SearchMode.SKILLS || option?.value === SearchMode.TEAM) {
            onSearchModeChange(option.value);
          }
        }}
      />
      <SearchInput
        value={searchTerm}
        onChange={(e) => onSearchTermChange(e.target.value)}
        placeholder={getPlaceholder()}
      />
    </div>
  );
};

export default SearchControls; 